import './product-hero.scss';
import { register } from 'swiper/element/bundle';

// Le markup <swiper-container> du bloc est auto-init (config par attributs) :
// register() définit les custom elements (gardé en interne, appels multiples ok).
register();
